<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
  <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
  <div class="col-sm-6 col-md-6 col-xl-5 m-auto text-left">
    <label class="custom-control custom-checkbox chkbox mb-2" for="home1">
      <input type="checkbox" class="custom-control-input mgntp10" id="home1" value="Single family home" name="property"
        [(ngModel)]="hgProperty.prop1" (click)="getProperty($event)" />
      <label class="custom-control-label font20" for="home1">Single family home</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="home2">
      <input type="checkbox" class="custom-control-input mgntp10" id="home2" value="Apartment or condominium" name="property"
        [(ngModel)]="hgProperty.prop2" (click)="getProperty($event)" />
      <label class="custom-control-label font20" for="home2">Apartment or condominium</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="home3">
      <input type="checkbox" class="custom-control-input mgntp10" id="home3" value="Townhouse" name="property"
        [(ngModel)]="hgProperty.prop3" (click)="getProperty($event)" />
      <label class="custom-control-label font20" for="home3">Townhouse</label>
    </label>
    <label class="custom-control custom-checkbox chkbox mb-2" for="home4">
      <input type="checkbox" class="custom-control-input mgntp10" id="home4" value="Manufactured home" name="property"
        [(ngModel)]="hgProperty.prop4" (click)="getProperty($event)" />
      <label class="custom-control-label font20" for="home4">Manufactured home</label>
    </label>
  </div>
  <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
  <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}"(click)="next();">Next</button>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
    <div class="d-flex h-100 row col-sm-12 pr-0">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
      <div class="col-12 px-0">
        <label class="custom-control custom-checkbox chkbox mb-2" for="home1_mob">
          <input type="checkbox" class="custom-control-input mgntp10" id="home1_mob" value="Single family home" name="property"
            [(ngModel)]="hgProperty.prop1" (click)="getProperty($event)" />
          <label class="custom-control-label font20" for="home1_mob">Single family home</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="home2_mob">
          <input type="checkbox" class="custom-control-input mgntp10" id="home2_mob" value="Apartment or condominium" name="property"
            [(ngModel)]="hgProperty.prop2" (click)="getProperty($event)" />
          <label class="custom-control-label font20" for="home2_mob">Apartment or condominium</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="home3_mob">
          <input type="checkbox" class="custom-control-input mgntp10" id="home3_mob" value="Townhouse" name="property"
            [(ngModel)]="hgProperty.prop3" (click)="getProperty($event)" />
          <label class="custom-control-label font20" for="home3_mob">Townhouse</label>
        </label>
        <label class="custom-control custom-checkbox chkbox mb-2" for="home4_mob">
          <input type="checkbox" class="custom-control-input mgntp10" id="home4_mob" value="Manufactured home" name="property"
            [(ngModel)]="hgProperty.prop4" (click)="getProperty($event)" />
          <label class="custom-control-label font20" for="home4_mob">Manufactured home</label>
        </label>
      </div>
      <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
      <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right" >
          <h1 class="ansMob text-right">{{property}}</h1>
      </div>
      </div>
    </div>
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active9.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active5.png"></span>
    <h5 class="clr333 processtxt">25% Completed</h5>
  </div>
</div> -->